import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ListSubheader from "@mui/material/ListSubheader";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";

function CustomImageList({
  width,
  height,
  maxHeight = "400px",
  attachments,
  onImageClick = () => {},
}) {
  if (!attachments) return null;

  const onClickHandler = (item) => {
    onImageClick(item);
  };

  return (
    <>
      <ImageListItem key="Subheader" cols={1} rowHeight={240}>
        <ListSubheader component="div">Imagenes</ListSubheader>
      </ImageListItem>
      <ImageList sx={{ width: width, height: height }} cols={3}>
        {attachments.map((item) => (
          <ImageListItem
            key={item.url}
            onClick={() => onClickHandler(item)}
            sx={{ cursor: "pointer" }}
          >
            <img
              srcSet={`${item.url}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${item.url}?w=248&fit=crop&auto=format`}
              alt={item.name}
              loading="lazy"
              style={{ maxHeight: maxHeight }}
            />
            <ImageListItemBar
              title={item.name}
              subtitle={item.type}
              actionIcon={
                <IconButton
                  sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                  aria-label={`info about ${item.name}`}
                >
                  {/* <InfoIcon /> */}
                </IconButton>
              }
            />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  );
}

export default CustomImageList;
